import React, { useEffect, useContext, useState } from 'react'
import './styles.scss'

import get from 'lodash/get'

import AUTH_ACTIONS from '../../../../../store/actions/authAction'
import contractContext from '../../../../../store/contexts/contractContext'

import SingleDigitsInput from '../../../../../components/Inputs/SingleDigitsInput'
import GeneralInputMask from '../../../../../components/GeneralInputMask'
import Button, { NoBackgroundButton } from '../../../../../components/Button'

import { filterString } from '../../../../../helpers/cleanup'
import ErrorComponent from 'components/ErrorComponent'
import { User } from 'types/user'
import COLORS from 'styles/colors'

export default function CellPhoneValidation() {
  const context = useContext(contractContext)
  const phoneNumber = get(context, 'auth.userData.phone', '')

  const [hasRegisteredPhone, setPhoneRegister] = useState(false)
  const [registeredPhoneNumber, setPhoneNumber] = useState(phoneNumber)
  const [pin, setPin] = useState('')
  const [errors, setErrors] = useState<string[]>([])
  const [smsCooldown, setSmsCoolDown] = useState(false)
  const [localUser, setLocalUser] = useState<User | null>(null)

  const sendSMS = async (shouldSendSms = false) => {
    if (hasRegisteredPhone || shouldSendSms) {
      const { authDispatch, userData } = context.auth
      const { requestConfirmationPin } = context.services

      handleSmsCooldown()

      const { res } = await requestConfirmationPin(phoneNumber, userData.accessToken)

      if (!!localUser) {
        localUser.phone = phoneNumber
      }

      authDispatch({
        type: AUTH_ACTIONS.RECEIVE_CONFIRMATION_PIN_DATA,
        value: res,
      })
    }
  }

  const handleSmsCooldown = () => {
    setSmsCoolDown(true)

    setTimeout(() => setSmsCoolDown(false), 60000)
  }

  const nextStep = () => {
    const { handleStepChange, auth } = context

    const hasFilledPersonalData = get(auth, 'userData.filled_personal_data', false)

    const destinantion = Boolean(hasFilledPersonalData) ? 'TenantRegister' : 'CPFRegister'

    handleStepChange(destinantion)
  }

  const handlePin = async () => {
    const { verifyConfirmationPin } = context.services
    const {
      userData: { id, accessToken },
      phoneConfirmation: { pinId },
    } = context.auth

    try {
      await verifyConfirmationPin({
        pinId,
        pin,
        userId: id,
        token: accessToken,
      })

      // Update localstorage with the confirmed number after validation
      if (localUser) {
        localUser.phone_confirmed = true

        localStorage.setItem('current_user', JSON.stringify({ user: localUser, accessToken }))
      }

      setErrors([])
    } catch (err) {
      if (err.message.includes('Form data incorrect')) {
        setErrors(['Código inserido inválido'])
      } else {
        setErrors([`erro: ${err.message}`])
      }

      throw new Error()
    }
  }

  const handlePhoneRegister = async () => {
    const { authDispatch } = context.auth
    authDispatch({
      type: AUTH_ACTIONS.SET_LOGGED_USER_PHONE,
      value: filterString(registeredPhoneNumber, ['(', ')', ' ', '-']),
    })

    setPhoneRegister(true)

    await sendSMS(true)
  }

  const handleValidationAction = async () => {
    const { setIsLoading } = context
    if (!hasRegisteredPhone) {
      await handlePhoneRegister()
      return
    }

    setIsLoading(true)
    try {
      await handlePin()
    } catch (err) {
      setIsLoading(false)
      return
    }
    setIsLoading(false)
    nextStep()
  }

  const handlePinValue = (value: string[] | number[]) => setPin(value.join(''))

  const checkLocalStorage = () => {
    const data = localStorage.getItem('current_user')
    if (data) {
      setLocalUser(JSON.parse(data).user)
    }
  }

  useEffect(() => {
    checkLocalStorage()
  }, [])

  return (
    <div className='cellphone-validation-container'>
      {hasRegisteredPhone ? (
        <>
          <p className='margin-bottom'>
            enviamos um código SMS <br />
            por favor insira ele abaixo
          </p>
          <div className='errors-wrapper'>
            <ErrorComponent errors={errors} />
          </div>
          <div style={{ width: 300 }}>
            <SingleDigitsInput onChange={handlePinValue} />
          </div>
          <NoBackgroundButton
            title='Reenviar código'
            onClick={sendSMS}
            className='margin-top'
            disabled={smsCooldown}
          />
        </>
      ) : (
        <>
          <p>Cadastre seu Celular</p>
          <div className='phone-input-container'>
            <GeneralInputMask
              label='Telefone'
              mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              handleChange={(e) => setPhoneNumber(e.target.value)}
              value={registeredPhoneNumber}
            />
          </div>
        </>
      )}
      <div className='cellphone-register-footer'>
        {hasRegisteredPhone && (
          <Button
            style={{
              marginRight: '10px',
              backgroundColor: 'white',
              color: COLORS.brand.primary,
            }}
            title='Voltar'
            onClick={() => setPhoneRegister(false)}
          />
        )}
        <Button title='Confirmar' onClick={handleValidationAction} />
      </div>
    </div>
  )
}
